module.exports = __webpack_public_path__ + "img/indonesia.ae9157a7.png";